<div class="select-wrap">
  <select [id]="id" [name]="name" class="base-select" [ngClass]="{ fluid: isFluid }" [disabled]="disabled"
    [ngStyle]="{ 'margin-bottom': mb, 'margin-top': mt }" [ngModel]="value" (ngModelChange)="onSelect($event)"
    (focus)="handleFocus($event)" (blur)="handleBlur($event)">
    <option [ngValue]="null" disabled [selected]="!value">{{ placeholder }}</option>
    <option *ngFor="let option of options" [ngValue]="option">{{ optionDisplay(option) }}</option>
  </select>
  <div class="custom-carrot">
    <app-svg-loader height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
  </div>
</div>